var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNothingFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 459.94 429.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "m140.17 114-.85 225.45-68.78-.22-.1 30.3A34.39 34.39 0 0 0 104.72 404l34.39.11 198.74.64a34.39 34.39 0 0 0 34.5-34.28l1.06-290.14-198.74-.64a34.39 34.39 0 0 0-34.5 34.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fda01f",
    d: "M70.44 339.31h68.78v30.3A34.39 34.39 0 0 1 104.83 404a34.39 34.39 0 0 1-34.39-34.39v-30.3Z",
    transform: "rotate(.18 108.825 381.802)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.1,
    cy: 369.99,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5061",
    d: "M51.22 385c-2.8-6.46-.68-10.42-.68-15 0-9.63 3.22-20.54 9-27.38A52.88 52.88 0 0 1 62 357.74c0 9.63-5 20.4-10.78 27.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.82,
    cy: 357.81,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5061",
    d: "M86.14 371.06c0 3.8 1.55 6.84-.56 12-9-7.21-15.84-19.31-15.84-31.78a55.48 55.48 0 0 1 1.91-13c9.04 7.13 14.49 20.31 14.49 32.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.94,
    cy: 349.31,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M68.1 404.09v-51.14M68.1 372.98l7.97-9.11M68.1 383.86l11.49-13.13M68.1 395.07l11.86-13.56M68.1 373l-9.66-11.05M68.1 383.88l-11.86-13.56M68.1 395.09l-11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.94,
    cy: 349.31,
    fill: "none",
    stroke: "#008ef8",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M92.94 332.27v71.95M92.94 352.3l9.65-11.03M92.94 363.18l11.86-13.56M92.94 374.39l11.86-13.56M92.94 352.32l-9.67-11.05M92.94 363.2l-11.86-13.56M92.94 374.41l-11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.82,
    cy: 357.81,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M37.82 340.77v63.45M37.82 360.8l9.65-11.03M37.82 371.68l11.86-13.56M37.82 382.89l11.86-13.56M37.82 360.82l-9.66-11.05M37.82 371.7l-11.86-13.56M37.82 382.92l-11.86-13.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008ef8",
    d: "M390.8 331.67h18.03v103.59H390.8z",
    transform: "rotate(-38.51 399.828 383.478)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0234c1",
    d: "m389.19 384.59.18.23 9.53 12c5.09-9.15 1.36-25.12.55-28.26l-11-13.77s8.02 20.13.74 29.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 106.47,
    height: 79.6,
    x: 95.82,
    y: 221.2,
    fill: "none",
    stroke: "#0234c1",
    strokeMiterlimit: 10,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96.93,
    height: 69.41,
    x: 100.58,
    y: 226.29,
    fill: "#008ef8",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.18,
    height: 59.12,
    x: 161.99,
    y: 231.22,
    fill: "#c1e3f7",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.35,
    height: 20.24,
    x: 108.81,
    y: 270.11,
    fill: "#c1e3f7",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.35,
    height: 7.29,
    x: 108.81,
    y: 231.22,
    fill: "#c1e3f7",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.79,
    height: 18.79,
    x: 109.68,
    y: 245.01,
    fill: "#c1e3f7",
    rx: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.79,
    height: 18.79,
    x: 135.84,
    y: 245.01,
    fill: "#c1e3f7",
    rx: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    width: 106.47,
    height: 79.6,
    x: 321.75,
    y: 46.46,
    fill: "none",
    stroke: "#0234c1",
    strokeMiterlimit: 10,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96.93,
    height: 69.41,
    x: 326.52,
    y: 51.56,
    fill: "#008ef8",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.18,
    height: 59.12,
    x: 387.93,
    y: 56.49,
    fill: "#c1e3f7",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.35,
    height: 20.24,
    x: 334.75,
    y: 95.37,
    fill: "#c1e3f7",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.35,
    height: 7.29,
    x: 334.75,
    y: 56.49,
    fill: "#c1e3f7",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.79,
    height: 18.79,
    x: 335.62,
    y: 70.27,
    fill: "#c1e3f7",
    rx: 3.66
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.79,
    height: 18.79,
    x: 361.77,
    y: 70.27,
    fill: "#c1e3f7",
    rx: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M310.27 313.52 374.14 145l68.79.23.09-30.31a34.39 34.39 0 0 0-34.28-34.5l-34.39-.11-198.74-.64a34.39 34.39 0 0 0-34.5 34.33l-1.06 290.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fda01f",
    d: "M374.25 80.44H443v30.3a34.39 34.39 0 0 1-34.39 34.39 34.39 34.39 0 0 1-34.39-34.39v-30.3Z",
    transform: "rotate(-179.82 408.633 112.803)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5061",
    d: "M358.55 331.61a52.24 52.24 0 0 1-5.08 3.56l9.25 11.63 9.69-7.72-9.25-11.62a54 54 0 0 1-4.61 4.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.09,
    cy: 277.36,
    r: 61.88,
    fill: "#489ee0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.85,
    height: 60.71,
    x: 177.82,
    y: 325.41,
    fill: "#008ef8",
    rx: 7,
    transform: "rotate(1.81 215.833 354.986)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.85,
    height: 60.71,
    x: 165.81,
    y: 133.9,
    fill: "#008ef8",
    rx: 7,
    transform: "rotate(1.81 203.633 163.95)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0850ec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M244.85 264.34 160.3 261M244.59 288.08l-84.31-2.03M251.36 309.2l-75.79-.11M256.52 140.04l92.43 3.65M256.16 164.04l91.89 3.64M271.82 186.77l77.3 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M443.22 174.11a78.74 78.74 0 0 1 1.21 7.89c.3 2.63.48 5.27.65 7.91s.22 5.29.2 7.94a76.2 76.2 0 0 1-.35 8 76.33 76.33 0 0 1-1.2-7.89c-.31-2.64-.49-5.28-.65-7.92s-.22-5.29-.21-7.94.13-5.33.35-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M459.94 189.11a79.18 79.18 0 0 1-7.89 1.21c-2.64.3-5.28.48-7.92.64s-5.29.23-7.94.21a78.83 78.83 0 0 1-8-.35 78.74 78.74 0 0 1 7.89-1.21c2.63-.3 5.27-.48 7.91-.64s5.29-.22 8-.21 5.28.08 7.95.35ZM424.2 207.36a36.56 36.56 0 0 1 1.06 5.3c.24 1.77.42 3.54.51 5.32s.12 3.57.07 5.36a36.6 36.6 0 0 1-.49 5.38 36.6 36.6 0 0 1-1.07-5.3c-.24-1.77-.42-3.55-.51-5.33s-.11-3.56-.06-5.35a36.35 36.35 0 0 1 .49-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M435.45 217.46a37.7 37.7 0 0 1-5.3 1.07c-1.77.24-3.54.41-5.32.51s-3.57.11-5.36.06a36.6 36.6 0 0 1-5.38-.49 36.56 36.56 0 0 1 5.3-1.06c1.77-.24 3.55-.42 5.33-.51s3.56-.12 5.35-.07a39.26 39.26 0 0 1 5.38.49ZM24.26 215c.55 2.63.91 5.26 1.2 7.89s.49 5.28.65 7.92.22 5.29.21 7.94a78.84 78.84 0 0 1-.36 8c-.55-2.62-.91-5.25-1.2-7.88s-.49-5.28-.65-7.92-.22-5.29-.2-7.94a76.2 76.2 0 0 1 .35-8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M41 230a78.7 78.7 0 0 1-7.89 1.2c-2.63.3-5.27.49-7.92.65s-5.29.23-7.94.21a79 79 0 0 1-8-.35 78.74 78.74 0 0 1 7.89-1.21c2.63-.3 5.27-.48 7.92-.64s5.29-.23 7.94-.21a79 79 0 0 1 8 .35ZM43.12 247.42a36.56 36.56 0 0 1 1.06 5.3c.25 1.77.42 3.55.51 5.33s.12 3.56.07 5.35a36.35 36.35 0 0 1-.49 5.38 38 38 0 0 1-1.07-5.3c-.24-1.77-.41-3.55-.5-5.33s-.12-3.56-.07-5.35a36.47 36.47 0 0 1 .49-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M54.37 257.53a37.53 37.53 0 0 1-5.29 1.06c-1.78.24-3.55.42-5.33.51s-3.56.12-5.35.07a36.35 36.35 0 0 1-5.38-.49 34.93 34.93 0 0 1 5.29-1.07c1.78-.24 3.55-.42 5.33-.51s3.56-.1 5.36-.1a36.35 36.35 0 0 1 5.37.53ZM247.12 0c.55 2.62.91 5.25 1.2 7.89s.49 5.27.65 7.92.22 5.29.21 7.94-.08 5.3-.35 8a78.74 78.74 0 0 1-1.21-7.89c-.3-2.63-.49-5.27-.65-7.92s-.22-5.29-.2-7.94a79 79 0 0 1 .35-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M263.83 15c-2.62.55-5.25.91-7.89 1.2s-5.27.49-7.91.65-5.29.22-7.95.21a79 79 0 0 1-8-.36c2.62-.55 5.25-.91 7.89-1.2s5.28-.49 7.92-.65 5.29-.22 7.94-.2a76 76 0 0 1 8 .35ZM266 32.4a37.7 37.7 0 0 1 1.07 5.3c.24 1.77.41 3.54.51 5.32s.11 3.57.06 5.35a36.61 36.61 0 0 1-.49 5.39 36.56 36.56 0 0 1-1.06-5.3c-.25-1.77-.42-3.55-.51-5.33s-.12-3.56-.07-5.35a36.35 36.35 0 0 1 .49-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M277.24 42.5a38 38 0 0 1-5.3 1.07c-1.77.24-3.55.41-5.33.51s-3.56.11-5.35.06a36.35 36.35 0 0 1-5.38-.49 36.29 36.29 0 0 1 5.3-1.06c1.77-.25 3.54-.42 5.32-.51s3.57-.12 5.35-.07a36.61 36.61 0 0 1 5.39.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.5 404.22h389.82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.73,
    cy: 276.91,
    r: 72,
    fill: "#c1e3f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.09,
    cy: 277.36,
    r: 61.88,
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0234c1",
    d: "m254.67 269.75 57.46.8.16-12-54.9-.76a62.79 62.79 0 0 0-2.72 11.96ZM256.37 293.66l58.17.8.17-12-60.37-.84a62.13 62.13 0 0 0 2.03 12.04ZM263.88 310.58a59.64 59.64 0 0 0 4.11 5.71l45.58.64.4-12-53.63-.73a60.74 60.74 0 0 0 3.54 6.38Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFound);
export default __webpack_public_path__ + "static/media/nothing-found.d86ab604f0dd1d016e4d1ead9156a7ef.svg";
export { ForwardRef as ReactComponent };